import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@chakra-ui/react";
const PageContent = ({ children }) => (_jsx(Box, Object.assign({ px: "6", flex: "1", pb: "8" }, { children: _jsx(Box, Object.assign({ maxW: "7xl", mx: "auto" }, { children: children })) })));
export default PageContent;
